// extracted by mini-css-extract-plugin
module.exports = {"TextareaGroup":"Textarea_TextareaGroup__2x08s","Label":"Textarea_Label__11w1w","Textarea":"Textarea_Textarea__24cPQ"};